import styled from "@emotion/styled";
import Colors from "styles/colors";
import { BRAND_BLACK_TEXT_COLOR } from "styles/color-consts";
const CLEAR_ALL_TEXT_COLOR = "#6c63ff";
export const StyledWhatsNewPageFilters = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  padding: 24px;
  padding-top: 0;
  margin-right: 16px;
  min-width: 340px;
  padding-bottom: 108px;
  box-shadow: 32px 12px 40px -32px rgba(29, 140, 242, 0.16);
  height: calc(100% - 24px);

  .filters-content {
    position: sticky;
    top: 80px;

    .filters-title {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      margin-bottom: 32px;
      justify-content: space-between;
      margin-left: 16px;
      margin-right: 18px;
    }

    .text-filter-container {
      display: flex;
      align-items: center;
      border-radius: 8px;
      border: 1px solid;
      border-color: ${Colors.gainsboro};
      margin: 42px 12px;
      position: relative;

      .search-icon-wrapper {
        position: absolute;
        display: flex;
        padding-left: 16px;
      }

      input {
        flex: 1;
        padding: 12px;
        border-radius: 4px;
        font-size: 0.875rem;
        border-radius: 8px;
        border: none;
        color: ${Colors["mud"]};
        padding-left: 42px;
        width: 100%;

        &:focus {
          outline: none;
        }
      }
    }

    .filters-title h2 {
      margin: 0;
      font-size: 1.125rem;
      font-weight: 500;
      line-height: 18px;
    }

    .clear-all {
      display: flex;
      font-size: 0.875rem;
      color: ${Colors[BRAND_BLACK_TEXT_COLOR]};
      cursor: pointer;
      align-self: end;
    }

    .clear-all:hover {
      color: ${CLEAR_ALL_TEXT_COLOR};
    }
  }
`;
